import React from 'react';
import { Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  // what will happen; the subject (an email or a branch) can be shown in bold
  message: React.ReactNode;
  confirmText: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// A centred confirmation popup, styled like the Edit branch popup (used for Delete and Remove)
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmText,
  onConfirm,
  onCancel,
}: ConfirmDialogProps): JSX.Element {
  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      onCancel={onCancel}
      maskClosable={false}
      destroyOnClose
      centered
      getContainer={false}
      width={460}
      className="settings__modal"
    >
      <div className="confirm-dialog">
        <span className="confirm-dialog__icon">
          <ExclamationCircleOutlined />
        </span>
        <p className="confirm-dialog__text">{message}</p>
      </div>
      <div className="settings__actions">
        <Button
          onClick={onCancel}
          className="settings__button settings__button--ghost"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          className="settings__button settings__button--primary"
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
}
